module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_25.a4626753.png";